type ProjectPickerSearch = {
  /** Set by `openOneProject` where it had to pick a project for a customer who
   *  has several and had chosen none — what opens the picker, once. */
  choose?: boolean
}

/** Every project route that can show the picker validates its search through
 *  this, so the flag survives the redirect that sets it. */
export const validateProjectPickerSearch = (
  search: Record<string, unknown>,
): ProjectPickerSearch => ({
  choose: search.choose === true || search.choose === 'true' ? true : undefined,
})
